import { MenuItem, Select, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import Button from "../../../../components/Common/Button";
import { selectUid } from "../../../../slices/auth";
import { updateStudentBgItem } from "../../../../api/common";
import "./style.scss";
import { professionScopes } from "../../../../db/datasets/professions";
import { analyticsEvents, bgItemTypes, jobContracts } from "../../../../db/models/const";

interface Props {
	handleGoNext: Function;
}

const StudentOnboardingJob = ({ handleGoNext }) => {
	const { t } = useTranslation();
	const { register, handleSubmit, control, errors } = useForm();
	const [loading, setLoading] = useState(false);
	const uid = useSelector(selectUid);

	const onSave = (form) => {
		const j = {
			scopeId: form.scope.id,
			label: form.label,
			contractId: form.contractId,
			begin: form.begin,
			end: form?.end || null,
		};

		setLoading(true);
		updateStudentBgItem(uid, bgItemTypes.JOB, j, true)
			.then(() => {
				setLoading(false);

				handleGoNext();
			})
			.catch((error) => setLoading(false));
	};

	return (
		<div className="studentOnboardingCompetence dark-bg">
			<div className="container">
				<div className="card p-4">
					<h2 className="fs-2 fw-bolder">{t("student_onboarding_job_title")}</h2>
					<p className="fs-4 mb-4">{t("student_onboarding_job_subtitle")}</p>
					<form onSubmit={handleSubmit(onSave)}>
						<div className="element">
							<div className="label">{t("student_job_scope_label")}</div>
							<Controller
								render={({ onChange, ...props }) => (
									<Autocomplete
										{...props}
										options={professionScopes}
										getOptionLabel={(option) => t(option.label)}
										renderInput={(params) => <TextField {...params} />}
										onChange={(e, x) => {
											onChange(x);
										}}
									/>
								)}
								name={"scope"}
								rules={{ required: true }}
								control={control}
							/>
							{errors.scope && <p className="text-danger">{t("student_job_scope_error")}</p>}
						</div>
						<div className="element">
							<div className="label">{t("student_job_contract_label")}</div>
							<Controller
								render={({ onChange, ...props }) => (
									<Select fullWidth {...props} onChange={(e) => onChange(e.target.value)}>
										{jobContracts.map((x) => (
											<MenuItem key={x.id} value={x.id}>
												{t(x.label)}
											</MenuItem>
										))}
									</Select>
								)}
								name={"contractId"}
								rules={{ required: true }}
								control={control}
							/>
							{errors.contractId && <p className="text-danger">{t("student_job_contract_error")}</p>}
						</div>
						<div className="element">
							<div className="label">{t("student_job_label_label")}</div>
							<input type="text" ref={register({ required: true })} name="label" placeholder={t("student_job_label_ph")}></input>
							{errors.label && <p className="text-danger">{t("student_job_label_error")}</p>}
						</div>
						<div className="element">
							<div className="label">{t("student_job_begin_label")}</div>
							<Controller control={control} name="begin" rules={{ required: true }} render={({ onChange, onBlur, value }) => <ReactDatePicker onChange={onChange} onBlur={onBlur} selected={value} dateFormat="MM/yyyy" showMonthYearPicker />} />
							{errors.begin && <p className="text-danger">{t("student_job_begin_error")}</p>}
						</div>
						<div className="element">
							<div className="label">{t("student_job_end_label")}</div>
							<Controller control={control} name="end" render={({ onChange, onBlur, value }) => <ReactDatePicker onChange={onChange} onBlur={onBlur} selected={value} dateFormat="MM/yyyy" showMonthYearPicker />} />
						</div>
						{!loading && (
							<Button type="submit" filled loading={loading} backgroundColor="#3392E8" borderColor="#3392E8" className="mb-3">
								{t("student_onboarding_nextBtn")}
							</Button>
						)}
						{loading && (
							<div className="loader">
								<ClipLoader size={20} color={"#7400b8"} loading={true} />
							</div>
						)}
					</form>
					{!loading && (
						<Button light loading={loading} onClick={() => handleGoNext()}>
							Salta
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default StudentOnboardingJob;
